import styled, { css } from 'styled-components';
import { theme, palette } from 'styled-tools';

interface BtnStyleProps {
    height?: number;
    backGroundColor?: string;
    boarderColor?: string;
    color?: string;
    fontStyle?: string;
    radius?: number;
}

export const Button = styled.button<BtnStyleProps>`
    width: 100%;
    height: ${(props) => props.height ? props.height : css`36`}px;
    cursor: pointer;
    outline: 0;
    line-height: normal;
    ${(props) => (props.color ? css`color: ${palette(props.color)};` : null)}
    ${(props) => (props.boarderColor ? css`border: 1px solid ${palette(props.boarderColor)};` : css`border: 0;`)}
    ${(props) => (props.backGroundColor ? css`background-color: ${palette(props.backGroundColor)};` : null)}
    border-radius: ${(props) => props.radius ? props.radius : css`8`}px;
    ${(props) => props.fontStyle ? css`${theme(`fontStyle.${props.fontStyle}`)}` : null}

    > * {
        cursor: pointer;
    }
`;